import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { AccountSnapshot } from '@core/states/account/account.snapshot';
import { environment } from '@env/environment';

@Injectable()
export class RequestAuthInterceptor implements HttpInterceptor {
  constructor(private readonly accountSnapshot: AccountSnapshot) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!request.url.includes(environment.api.clientPortal)) {
      return next.handle(request);
    }
    const preparedRequest = this.prepare(request);
    return next.handle(preparedRequest);
  }

  private prepare(request: HttpRequest<unknown>): HttpRequest<unknown> {
    const accessToken = this.accountSnapshot.jwt;

    if (!accessToken?.length) {
      return request;
    }

    return request.clone({
      headers: request.headers.set('Authorization', `Bearer ${accessToken}`),
    });
  }
}
